/**
 * SR5 — Suporte e Resistência 5.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLBands.cs, classe FML.SR5).
 * Overlay de preço, 10 linhas, SEM parâmetros:
 *
 *   P  = (H + L + C) / 3      YL = REF(L,1)      YH = REF(H,1)
 *   R1 = 2P − YL              S1 = 2P − YH
 *   R2 = (P − S1) + R1        S2 = P − (R1 − S1)
 *   R3 = (P + R2) − S1        S3 = (P − R2) + S1
 *   R4 = (P + R3) − S1        S4 = (P − R3) + S1
 *   R5 = (P + R4) − S1        S5 = (P − R4) + S1
 *
 * Pacote na ordem [R1, S1, R2, S2, R3, S3, R4, S4, R5, S5] — é essa ordem que
 * define a cor default de cada linha (paleta por índice do engine).
 *
 * ⚠️ NÃO é o `pivotPoints` do odin com mais níveis: aquele é por PERÍODO
 * (dia/semana, pivô constante até a virada, `PP` do período anterior); este é
 * por BARRA, com o P da barra atual e H/L da anterior, e as fórmulas de R2/R3
 * são outras. Também não é o `supportResistance` (ex-classe `SR`), que usa só a
 * barra atual e tem 1 nível + fill.
 *
 * ⚠️ Os níveis PODEM se cruzar (S acima de R em barras de queda forte) — é a
 * cadeia do engine, não defeito do porte: R3..R5 e S3..S5 acumulam `YH` e
 * `range`, e a ordem deixa de ser monotônica. Confirmado no oráculo (ITSA3
 * barra 1: S5 13,96 > R5 13,78).
 *
 * Paridade provada em __tests__/sr5.silverlight.test.js.
 */
import { add, sub, mul, div, ref } from "./silverlightDsl";

export default function () {
  let options = {};

  function calculator(data) {
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));
    const close = data.map((d) => num(d.close));

    // Mesma ordem de operações do Run() do engine.
    const p = div(add(add(high, low), close), 3);
    const yl = ref(low, 1);
    const yh = ref(high, 1);
    const r1 = sub(mul(p, 2), yl);
    const s1 = sub(mul(p, 2), yh);
    const r2 = add(sub(p, s1), r1);
    const s2 = sub(p, sub(r1, s1));
    const r3 = sub(add(p, r2), s1);
    const s3 = add(sub(p, r2), s1);
    const r4 = sub(add(p, r3), s1);
    const s4 = add(sub(p, r3), s1);
    const r5 = sub(add(p, r4), s1);
    const s5 = add(sub(p, r4), s1);

    const out = (arr, i) => (Number.isFinite(arr[i]) ? arr[i] : undefined);

    return p.map((_, i) => {
      const v = {
        r1: out(r1, i),
        s1: out(s1, i),
        r2: out(r2, i),
        s2: out(s2, i),
        r3: out(r3, i),
        s3: out(s3, i),
        r4: out(r4, i),
        s4: out(s4, i),
        r5: out(r5, i),
        s5: out(s5, i),
      };
      return Object.values(v).every((x) => x === undefined) ? undefined : v;
    });
  }

  calculator.undefinedLength = function () {
    // Toda série depende de YL/YH (REF(·,1)) — a barra 0 é NaN.
    return 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...x };
    return calculator;
  };

  return calculator;
}
